






























































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { currencyFormat, loadWidget } from '@/utils/helpers';
import { mixins } from 'vue-class-component';
import WidgetMixins from '@/mixins/WidgetMixins';
import { namespace } from 'vuex-class';
import ToolBar from '@/components/widgets/ToolBar.vue';
import { INotifications, IGraphData, IOrganizations } from '@/types/types';
import qs from 'qs';
//firebase
const appModule = namespace('apps');
const notificationModule = namespace('notifications');
const organizationModule = namespace('organizations');
const dashboardModule = namespace('dashboard');
@Component({
  components: {
    ToolBar,
    Notifications: loadWidget('pages/Notifications'),
    EmptyPage: loadWidget('pages/EmptyPage'),
    'internet-connection': loadWidget('pages/InternetConnection'),
    ProgressBar: loadWidget('widgets/CircularProgressLoader'),
    SnackBar: loadWidget('widgets/SnackBar'),
  },
  filters: {
    currencyFormat,
  },
})
export default class Applications extends mixins(WidgetMixins) {
  placeholder: string = require('@/assets/images/notification-list.jpg');
  @appModule.Getter('getApps') dashboard!: Array<object>;
  @dashboardModule.Getter('getCUDashboardStatistics') dashboardCount!: any;
  @dashboardModule.Getter('getCUDashboardGraph') dashboardGraph!: any;
  @organizationModule.Getter('getAllOrganizations') organizations!: Array<IOrganizations>;

  @notificationModule.Getter('getAllNotifications')
  notifications!: ReadonlyArray<INotifications>;

  showPushNotificationToast = false;
  markAsRead: boolean = true;
  tab: any = null;
  text: string = 'sample test';
  items: Array<string> = ['All Updates', 'Popular'];
  show: boolean = false;
  date: string = new Date().toISOString().substr(0, 10);

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;
  startDate: string | null = null;
  endDate: string | null = null;
  query: object | null = {};

  statuses: Array<{ text: string; value: string }> = [
    { text: 'DAILY', value: '$date' },
    { text: 'MONTHLY', value: '$month' },
    { text: 'YEARLY', value: '$year' },
  ];
  paymentStatuses: Array<string> = ['SUCCESS', 'FAILED'];
  paymentStatus: string = 'SUCCESS';
  status: string = '$date';
  organizationId: string | null = '';

  chartOptions: any = {
    chart: {
      type: 'bar',
      height: 350,
      background: 'transparent',
      fontFamily: 'Hanken Grotesk, sans-serif',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '15%',
        endingShape: 'rounded',
      },
    },
    colors: ['#FF0055'],
    legend: {
      show: true,
      fontSize: '11px',
      fontWeight: '500',
      fontFamily: 'Hanken Grotesk, sans-serif',
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: [],
      labels: {
        show: true,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          cssClass: 'ft',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Total Customers',
      },
      labels: {
        show: true,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          cssClass: 'ft',
        },
        formatter: (val: any) => {
          return val;
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    fill: {
      opacity: 1,
    },
  };
  areaChartOptions: any = {
    chart: {
      type: 'area',
      height: 350,
      background: 'transparent',
      fontFamily: 'Hanken Grotesk, sans-serif',
      toolbar: { show: false },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#10B981'],
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: [],
    },
    yaxis: {
      title: {
        text: 'Total Transactions',
      },
    },
  };

  series: any = [
    {
      name: 'Total Customers',
      data: [],
    },
  ];

  transactionsSeries: any = [
    {
      name: 'Total Transactions',
      data: [],
    },
    // {
    //   name: 'Total Approved IDs',
    //   data: [],
    // },
  ];

  isNotificationTurnedOn = false;
  isNotificationDenied = false;
  headers: any = [
    {
      text: 'Date',
      align: 'start',
      sortable: false,
      value: 'name',
    },
    { text: 'Customer', value: 'calories' },
    { text: 'Products', value: 'fat' },
    { text: 'Details', value: 'carbs' },
    { text: 'Price', value: 'protein' },
    { text: 'Delivery Cost', value: 'iron' },
  ];

  emptyState: any = {
    notification: require('@/assets/images/music.png'),
    popular: require('@/assets/images/commerce-and-shopping.png'),
  };

  get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  get areaColor(): string {
    const failed = this.paymentStatus === 'FAILED';
    if (this.isDark) return failed ? '#E5675A' : '#34D399';
    return failed ? '#D2483A' : '#10B981';
  }

  @Watch('isDark', { immediate: true })
  onThemeChange(dark: boolean): void {
    const foreColor = dark ? '#9AA3AE' : '#545D68';
    const borderColor = dark ? 'rgba(255, 255, 255, 0.1)' : '#E4E7EB';
    const themed = {
      theme: { mode: dark ? 'dark' : 'light' },
      tooltip: { theme: dark ? 'dark' : 'light' },
      grid: { borderColor },
    };
    this.chartOptions = {
      ...this.chartOptions,
      ...themed,
      chart: { ...this.chartOptions.chart, foreColor, background: 'transparent' },
      colors: [dark ? '#FF3D78' : '#FF0055'],
    };
    this.areaChartOptions = {
      ...this.areaChartOptions,
      ...themed,
      chart: { ...this.areaChartOptions.chart, foreColor, background: 'transparent' },
      colors: [this.areaColor],
    };
  }

  @Watch('organizations', {
    deep: true,
  })
  onOrganizationListChange(payload: Array<IOrganizations>): void {
    this.organizationId = payload.length > 0 ? payload[0]?._id : null;
  }

  @Watch('dashboardGraph')
  onDashboardGraphChange(payload: any): void {
    const xAxis = [...new Set([...payload.organizationByMemberCountGraph.map((item: IGraphData) => item.label)])];
    this.series[0].data = payload.organizationByMemberCountGraph.map((item: IGraphData) => item.value);
    this.chartOptions = {
      ...this.chartOptions,
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '15%',
          endingShape: 'rounded',
        },
      },
      xaxis: {
        categories: xAxis,
      },
    };

    const transactionXAxis = [
      ...new Set([...payload.organizationCollectionsByPeriod.map((item: IGraphData) => item.label)]),
    ];
    this.areaChartOptions = {
      ...this.areaChartOptions,
      xaxis: {
        categories: transactionXAxis,
      },
    };
    this.transactionsSeries[0].data = payload.organizationCollectionsByPeriod.map((item: IGraphData) => item.value);
  }

  @Watch('organizationId')
  onOrganizationIDChange(id: string): void {
    this.query = { ...this.query, paymentStatus: this.paymentStatus, groupBy: this.status, organizationId: id };
    this.$store.dispatch('dashboard/creditUnionDashboardGraph', `?${qs.stringify(this.query)}`);
  }
  @Watch('paymentStatus')
  onPaymentStatusChange(status: string): void {
    this.areaChartOptions = { ...this.areaChartOptions, colors: [this.areaColor] };
    this.query = { ...this.query, paymentStatus: status };
    this.$store.dispatch('dashboard/creditUnionDashboardGraph', `?${qs.stringify(this.query)}`);
  }
  @Watch('status')
  onStatusChange(state: string): void {
    this.query = { ...this.query, groupBy: state };
    this.$store.dispatch('dashboard/creditUnionDashboardGraph', `?${qs.stringify(this.query)}`);
  }
  @Watch('startDate')
  onStartDateChange(date: string): void {
    this.query = { ...this.query, startDate: date };
    this.$store.dispatch('dashboard/creditUnionDashboardGraph', `?${qs.stringify(this.query)}`);
  }
  @Watch('endDate')
  onEndDateChange(date: string): void {
    this.query = { ...this.query, endDate: date };
    this.$store.dispatch('dashboard/creditUnionDashboardGraph', `?${qs.stringify(this.query)}`);
  }

  // turning on notifications here

  // getting notifications token

  //sending notifications to server

  removeNotification(id: string): void {
    this.$store.dispatch('notifications/removeNotifications', { id });
  }

  clearAllNotifications(): void {
    this.$store.dispatch('notifications/clearAllNotifications');
  }

  markNotificationAsRead(notificationId: string): void {
    this.$store.dispatch(`notifications/markAsRead`, { id: notificationId });
  }

  created() {
    this.$store.dispatch('auth/me');
    this.$store.dispatch('dashboard/creditUnionDashboardStatistics');

    this.$store.dispatch('organizations/list', false);
  }
}
